const test = {
  appId: '129072067250329'
};

const prod = {
  appId: '470992062943504'
};

export default process.env.NODE_ENV === 'production' ? prod : test;



// WEBPACK FOOTER //
// ./app/Assets/js/features/facebook/fbCredentials.js